import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { toast, ToastContainer } from "react-toastify";
import api from "../../../../Services/api";
import {
  Editicon,
  Deleteicon,
  Viewicon,
  XCircleblack,
} from "../../../../Components/IconComponents";
import { useKeycloak } from "@react-keycloak/web";
import { Filter as FilterIcon } from "lucide-react";
import Loader from "react-spinner-loader";
import {
  keycloakbaseurl,
  getRoleDataByRoleNameURL,
  getallRolesByRealm,
  getRoleById,
  deleteRole,
  getAllRole,
  deletRoleById,
  getAllPermissions,
} from "../../../../Services/EndPoints";
import { getData, putDataWithBody } from "../../../../Services/Services";
import Table from "../../../../Components/UiComponents/Table/Table";
import Moment from "react-moment";
import { Modal, Button } from "react-bootstrap";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { roleTableDatacolumnsForExport } from "../../../../JsonData/RoleDetails";
import { useDispatch } from "react-redux";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { useTranslation } from "react-i18next";

const TODAY_STR = new Date().toISOString().split("T")[0];

const filterLabelStyle = {
  fontSize: "9.5px",
  fontWeight: 800,
  letterSpacing: ".3px",
  textTransform: "uppercase",
  color: "#98A2B3",
};

const filterControlStyle = {
  padding: "6px 10px",
  borderRadius: "8px",
  border: "1px solid #E4E7EC",
  fontSize: "12px",
  background: "#fff",
  color: "#1D2939",
  height: "34px",
  boxSizing: "border-box",
};

const RoleTable = forwardRef((props, ref) => {
  let roleDataArr = [];
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const [userdata, setUserdata] = useState([]);
  const qs = require("qs");
  const [roleData, setRoleData] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [isShow, invokeModal] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [permissionDataFrmService, setPermissionDataFrmService] = useState({});
  const { t, i18n } = useTranslation();
  const [searchData, setSearchData] = useState([]);
  // Date range only takes effect once "Apply" is clicked — pending values are
  // what the inputs show, applied values are what actually filters the data.
  const [pendingDateFrom, setPendingDateFrom] = useState("");
  const [pendingDateTo, setPendingDateTo] = useState("");
  const [appliedDateFrom, setAppliedDateFrom] = useState("");
  const [appliedDateTo, setAppliedDateTo] = useState("");
  const navigate = useNavigate();
  const addNewHandler = () => {
    navigate("/users/create-role");
  };
  useImperativeHandle(ref, () => ({
    refreshRoleTbl() {
      fetchAllRoles();
    },
  }));

  useEffect(() => {
    fetchAllRoles();
    getAllUserPermission();
  }, []);

  const formatSearchData = (data) => {
    return data.map(role => {
        // Create a string of comma-separated permission names
        const formattedPermissions = role.role_permission.map(permission => {
            return permissionDataFrmService[permission.permission_id] || "Unknown Permission";
        }).join(", "); // Join the permission names with a comma and space

        // Return the role with formatted permissions as a string...
        return {
            ...role,
            role_permission: formattedPermissions, // Replace array with the formatted string
        };
    });
};

useEffect(() => {
  if (searchData.length > 0) {
      const formattedData = formatSearchData(searchData);
      console.log(formattedData,"formatteddata");
      sendDataToCentralStore(formattedData);
      console.log(formattedData, "formatted search data");
  }
}, [searchData]);

  async function getAllUserPermission() {
    let permissionData = await getData(getAllPermissions);
    permissionData.forEach(function (permission) {
      permissionDataFrmService[permission.id] = permission.name;
    });
    setPermissionDataFrmService(permissionDataFrmService);
    console.log(permissionDataFrmService, "permdata");
  }
  const getLoggedInUserAuthToken = async () => {
    return keycloak.token;
  };
  const getSuperAdminUserAuthToken = async () => {
    return process.env.REACT_APP_URM_SUPERADMIN_AUTH_TOKEN;
  };
  const showUserDeleteModal = (roleId) => {
    setSelectedRoleId(roleId);
    invokeModal(true);
  };
  const populatRoleDataFrEdt = async (roleData) => {
    // const userData = await getRoleDataByRoleId(roleId);
    props.invokePrntComponentRoleDataUpdteFun(roleData);
  };
  const hideModal = () => {
    invokeModal(false);
  };

  const getURMHeader = async () => {
    const authToknObj = await getSuperAdminUserAuthToken();
    let headers = {
      "content-type": "application/json",
      Authorization: "Bearer " + authToknObj,
    };
    return headers;
  };

  const deleteRoleByRoleId = async (id) => {
    /*let data = { id: id };
    var res = await putDataWithBody(deleteRole, data, {});
    if (res.status == "success") {
      toast.success(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
      setIsdelete(false);
      fetchAllRoles();
    }
    
   let url =
      keycloakbaseurl +
      deletRoleById + selectedRoleId
    const authToknObj = await getLoggedInUserAuthToken();
    let headers = {
      "content-type": "application/json",
      Authorization: "Bearer " + authToknObj,
    };
    const response = await api.deleteData(url, headers);

    if (response.status == 204) {
      fetchAllRoles();
      invokeModal(false);
    }*/
  };

  const getURMRoleIdByAppRoleID = (id) => {
    let roleURMId = null;
    roleDataArr.forEach(function (roleObj) {
      if (roleObj.id == id) {
        roleURMId = roleObj.urm_role_id;
      }
    });
    return roleURMId;
  };
  const fetchAllRoles = async () => {
    setLoader(true);
    let roleArrFiltered = [];
    let rolearr = await getData(getAllRole);
    rolearr.forEach(function (roleObj) {
      if (roleObj.is_deleted != true) {
        roleArrFiltered.push(roleObj);
      }
    });
    setLoader(false);
    roleDataArr = roleArrFiltered;
    let sortedList = roleArrFiltered.sort((a, b) => {
      return b.createdOn - a.createdOn;
    });
    setRoleData(sortedList);
  };

  const isDateRangeInvalid =
    !!pendingDateFrom && !!pendingDateTo && new Date(pendingDateFrom) > new Date(pendingDateTo);

  const handleApplyDateFilter = () => {
    if (isDateRangeInvalid) return;
    setAppliedDateFrom(pendingDateFrom);
    setAppliedDateTo(pendingDateTo);
  };

  const filteredRoleData = React.useMemo(() => {
    if (!appliedDateFrom && !appliedDateTo) return roleData || [];
    return (roleData || []).filter((role) => {
      if (!role.createdOn) return false;
      const created = new Date(role.createdOn);
      if (appliedDateFrom && created < new Date(`${appliedDateFrom}T00:00:00`)) return false;
      if (appliedDateTo && created > new Date(`${appliedDateTo}T23:59:59`)) return false;
      return true;
    });
  }, [roleData, appliedDateFrom, appliedDateTo]);

  const hasActiveFilters = appliedDateFrom !== "" || appliedDateTo !== "";

  const clearAllFilters = () => {
    setPendingDateFrom("");
    setPendingDateTo("");
    setAppliedDateFrom("");
    setAppliedDateTo("");
  };

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = roleTableDatacolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("roletableheaders.rolename"),
        accessor: "name",
        disableSortBy: true,
      },
      // {
      //   Header: t("roletableheaders.description"),
      //   accessor: "description",
      //   disableSortBy: true,
      // },

      // {
      //   Header: t("roletableheaders.createdon"),
      //   accessor: "createdOn",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     if (props.value) {
      //       return <Moment format="DD/MM/YYYY, HH:mm ">{props.value}</Moment>;
      //     } else {
      //       return "NA";
      //     }
      //   },
      // },
      {
        Header: t("roletableheaders.description"),
        accessor: "description",
        disableSortBy: true,
        // width: 200,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullDescription, setFullDescription] = useState("");
          const [highlightedDescription, setHighlightedDescription] = useState(""); // New state for highlighted description
      
          const handleShowModal = (description) => {
            setFullDescription(description);
            setHighlightedDescription(description); // Set the description being viewed to highlight
            setShowModal(true);
          };
      
          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedDescription(""); // Reset the highlighted description when the modal is closed
          };
      
          const descriptionText = props.value || "NA";
          const truncatedDescription = descriptionText.length > 60 ? `${descriptionText.substring(0, 60)}...` : descriptionText;
      
          // Apply background color if the description is currently being viewed in the modal
          const isHighlighted = descriptionText === highlightedDescription;
          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector('.modal-content');
              el.style.cssText = 'background-color: #1c2038 !important; border-radius: 20px !important;';
            }, 0);
          }
      
          return (
            <span>
              <div
                style={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  // width: "500px",
                  cursor: 'pointer',  // Pointer cursor to indicate clickability
                  backgroundColor: isHighlighted ? '#18A3A0' : 'transparent', // Highlight background when viewed
                  padding: '2px 5px', // Add padding to give a little space around the text
                  borderRadius: '5px', // Rounded corners for the highlighted background
                }}
                title={descriptionText} // Tooltip with full description on hover
                onClick={() => handleShowModal(descriptionText)} // Open the modal with full description
              >
                {truncatedDescription}
              </div>
      
              {/* Modal to display the full description */}
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: '20px',  // Smooth rounded edges
                  border: 'none',        // Remove border to avoid white edges
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: '#2b6591', // Dark blue background for header
                    color: 'white',              // White text in the header
                    borderBottom: 'none',       // Remove bottom border to prevent white edges
                  }}
                >
                  <Modal.Title style={{ color: 'white', marginRight:"250px"  }}>Full Description</Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: '#fcfcfc', // Blue background for body
                    color: '#001b30',              // White text in the body
                    border: 'none',              // Remove border to prevent white edges
                    borderRadius: '0px',        // Remove radius to make it seamless
                    padding: '20px',             // Added padding for spacing
                    lineHeight: '1.8', 
                  }}
                >
                  <p>{fullDescription}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: '#fcfcfc', // Darker blue footer
                    color: 'white',              // White text in footer
                    borderTop: 'none',          // Remove top border to prevent white edges
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: '#2b6591', // Dark blue button
                      borderColor: '#003366',     // Dark border for button
                      borderRadius: '5px',        // Rounded button edges
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        }
      },      
      {
        Header: t("roletableheaders.createdon"),
        accessor: "createdOn",
        disableSortBy: true,
        // width: 180,  // Adjust the width for the "Created On" column
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
      },
  
      // {
      //   Header: t("roletableheaders.permission"),
      //   accessor: "role_permission",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     if (props.value && props.value.length > 0) {
      //       let permissionStr = "";
      //       let all_permissions = props.value;
      //       all_permissions.forEach(function (permission) {
      //         permissionStr +=
      //           permissionDataFrmService[permission["permission_id"]] + ",";
      //       });
      //       let permissionText = permissionStr;
      //       if (permissionText.length > 15) {
      //         permissionText = permissionText.substring(0, 15) + "...";
      //       }
      //       return <span title={permissionStr}>{permissionText}</span>;
      //     } else {
      //       return "NA";
      //     }
      //   },
      // },
      {
        Header: t("roletableheaders.permission"),
        accessor: "role_permission",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullPermissions, setFullPermissions] = useState("");
          const [highlightedPermissions, setHighlightedPermissions] = useState("");
      
          const handleShowModal = (permissions) => {
            setFullPermissions(permissions);
            setHighlightedPermissions(permissions); // Highlight the row
            setShowModal(true);
          };
      
          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedPermissions(""); // Reset highlight
          };
      
          if (props.value && props.value.length > 0) {
            let permissionStr = props.value
              .map((permission) => permissionDataFrmService[permission["permission_id"]])
              .join(", ");
            
            let truncatedText = permissionStr.length > 60 ? `${permissionStr.substring(0, 60)}...` : permissionStr;
      
            const isHighlighted = permissionStr === highlightedPermissions;
            if (showModal) {
              setTimeout(() => {
                let el = document.querySelector('.modal-content');
                el.style.cssText = 'background-color: #1c2038 !important; border-radius: 20px !important;';
              }, 0);
            }
      
            return (
              <span>
                <div
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    // maxWidth: "220px",
                    cursor: "pointer",
                    backgroundColor: isHighlighted ? "#18A3A0" : "transparent",
                    padding: "2px 5px",
                    borderRadius: "5px",
                  }}
                  title={permissionStr}
                  onClick={() => handleShowModal(permissionStr)}
                >
                  {truncatedText}
                </div>
      
                {/* Modal for full permissions */}
                <Modal
                  show={showModal}
                  onHide={handleCloseModal}
                  centered
                  dialogClassName="custom-modal"
                  style={{ borderRadius: "20px", border: "none" }}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#2b6591",
                      color: "white",
                      borderBottom: "none",
                    }}
                  >
                    <Modal.Title style={{ color: "white", marginRight:"250px" }}>Permissions</Modal.Title>
                    <XCircleblack
                      onClick={handleCloseModal}
                      width="1.5em"
                      height="1.5em"
                      className="cursor-pointer"
                    />
                  </Modal.Header>
                  <Modal.Body
                    style={{
                      backgroundColor: "#fcfcfc",
                      color: "#001b30",
                      border: "none",
                      borderRadius: "0px",
                      padding: "20px",
                      lineHeight: "1.8",
                    }}
                  >
                    <p>{fullPermissions}</p>
                  </Modal.Body>
                  <Modal.Footer
                    style={{
                      backgroundColor: "#fcfcfc",
                      color: "white",
                      borderTop: "none",
                    }}
                  >
                    <Button
                      variant="secondary"
                      onClick={handleCloseModal}
                      style={{
                        backgroundColor: "#2b6591",
                        borderColor: "#003366",
                        borderRadius: "5px",
                      }}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </span>
            );
          } else {
            return "NA";
          }
        },
      },
      
      // {
      //   Header: "Status  ",
      //   accessor: "status",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     return <StatusHandler props={props} />;
      //   },
      // },
      {
        Header: t("roletableheaders.action"),
        accessor: "action",
        disableSortBy: true,

        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
  const deletePopUp = () => {
    setIsdelete(!isdelete);
  };

  const deleteRoleByRoleId = async (id) => {
    // Delete logic
    let data = { id: id };
    var res = await putDataWithBody(deleteRole, data, {});
    if (res.status === "success") {
      toast.success(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
      setIsdelete(false);
      fetchAllRoles();
    }
  };

  const isDisabled = props.row.original.name === "DEOC" || props.row.original.name === "SEOC" || props.row.original.name === "DashboardOnly" ;

  const viewRole = () => {
    const role = props.row.original;
    // Permissions carry a userAccessType of "W" (Web) or "M" (Mobile); legacy
    // entries without the flag are treated as Web permissions.
    const webPermissionNames = (role.role_permission || [])
      .filter((p) => p.userAccessType === "W" || !p.userAccessType)
      .map((p) => permissionDataFrmService[p.permission_id])
      .filter(Boolean)
      .join(", ");
    const mobilePermissionNames = (role.role_permission || [])
      .filter((p) => p.userAccessType === "M")
      .map((p) => permissionDataFrmService[p.permission_id])
      .filter(Boolean)
      .join(", ");
    navigate("/users/view-role", {
      state: { data: role, webPermissionNames, mobilePermissionNames },
    });
  };

  return (
    <div className="usertable__actionsicon">
      <span onClick={viewRole}>
        <Viewicon value={props.value} className="cursor-pointer me-2" />
      </span>
      <span
        onClick={() =>
          !isDisabled && navigate("/users/create-role", {
            state: {
              data: props.row.original,
            },
          })
        }
      >
        <Editicon
          value={props.value}
          className={`cursor-pointer me-2 ${isDisabled ? 'text-muted' : ''}`}
          style={{ pointerEvents: isDisabled ? 'none' : 'auto', opacity: isDisabled ? 0.5 : 1 }}
        />
      </span>

      {isDisabled ? (
        <span>
          <Deleteicon
            value={props.value}
            className="me-1"
            style={{ color: 'lightgray', opacity: 0.5, pointerEvents: 'none' }} // Lighter effect
          />
        </span>
      ) : (
        <span onClick={deletePopUp}>
          <Deleteicon value={props.value} className="cursor-pointer mr-1" />
        </span>
      )}

      {isdelete && (
        <Confirmpopup
          className="DeltePopup"
          show={isdelete}
          title={t("deletepopuptext")}
          message={t("deletepopupmessage")}
          handleToggle={deletePopUp}
          row={props.row}
          name={props.row.original.name}
          deleteRow={deleteRoleByRoleId}
          cancel={t("cancelbutton")}
          action={t("actionbutton")}
        />
      )}
    </div>
  );
},    
      },
    ],
    [t]
  );

  const exportData = React.useMemo(
    () =>
      (filteredRoleData || []).map((role) => ({
        ...role,
        role_permission: (role.role_permission || [])
          .map((permission) => permissionDataFrmService[permission.permission_id] || "Unknown Permission")
          .join(", ") || "NA",
      })),
    [filteredRoleData, permissionDataFrmService]
  );

  console.log(roleData, "roledata");
  return (
    <div className="create-user role-mgmt-table">
      <style>{`
        #light .role-mgmt-table .iccc--table th {
          background: linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%) !important;
          color: #ffffff !important;
        }
        #light .role-mgmt-table .iccc--table tbody tr td,
        #light .role-mgmt-table .iccc--table tbody tr th {
          border: none !important;
        }
        #light .role-mgmt-table .iccc--table tbody tr td {
          background-color: #fff !important;
        }
        #light .role-mgmt-table .iccc--table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
        .role-mgmt-table .search-form {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .role-mgmt-table .search-form input[type="text"] {
          height: 36px !important;
          line-height: 34px !important;
          padding: 0 40px 0 12px !important;
          border: 1px solid #E4E7EC !important;
          border-radius: 8px !important;
          font-size: 12px !important;
          box-sizing: border-box !important;
        }
        .role-mgmt-table .search-form button {
          position: absolute !important;
          top: 0 !important;
          bottom: 0 !important;
          right: 0 !important;
          height: 36px !important;
          width: 36px !important;
          margin: 0 !important;
          padding: 0 !important;
          background-color: transparent !important;
          border: none !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .role-mgmt-table .search-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .role-mgmt-table .search-icon svg {
          display: block;
          color: #2E6DA4;
        }
      `}</style>
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div style={{ background: "#fff", border: "1px solid #EEF1F5", borderRadius: "10px", boxShadow: "0 1px 2px rgba(16,24,40,0.04)", padding: "10px 14px", margin: "12px 12px 12px 12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
          <span style={{ width: "20px", height: "20px", borderRadius: "6px", background: "#EBF4FA", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <FilterIcon size={11} color="#2E6DA4" />
          </span>
          <span style={{ fontSize: "12px", fontWeight: 800, color: "#2E6DA4" }}>Filters</span>
        </div>
        <style>{`
          .role-list-filter-bar input[type="date"] {
            position: relative;
            padding-right: 30px;
            display: inline-flex;
            align-items: center;
          }
          .role-list-filter-bar input[type="date"]::-webkit-datetime-edit {
            display: inline-flex;
            align-items: center;
            padding: 0;
            line-height: normal;
          }
          .role-list-filter-bar input[type="date"]::-webkit-datetime-edit-fields-wrapper {
            display: inline-flex;
            align-items: center;
          }
          .role-list-filter-bar input[type="date"]::-webkit-calendar-picker-indicator {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            margin: 0;
            padding: 0;
            cursor: pointer;
            opacity: 0.55;
          }
          .role-list-filter-bar input[type="date"]::-webkit-inner-spin-button,
          .role-list-filter-bar input[type="date"]::-webkit-clear-button {
            display: none;
          }
        `}</style>
        <div className="role-list-filter-bar" style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>Created From</label>
            <input
              type="date"
              value={pendingDateFrom}
              max={pendingDateTo && pendingDateTo < TODAY_STR ? pendingDateTo : TODAY_STR}
              onChange={(e) => setPendingDateFrom(e.target.value)}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>Created To</label>
            <input
              type="date"
              value={pendingDateTo}
              min={pendingDateFrom || undefined}
              max={TODAY_STR}
              onChange={(e) => setPendingDateTo(e.target.value)}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <button
            type="button"
            onClick={handleApplyDateFilter}
            disabled={!pendingDateFrom || !pendingDateTo || isDateRangeInvalid}
            title="Applies the Created From / Created To date range"
            style={{
              height: "34px", padding: "0 16px", borderRadius: "6px", fontSize: "12px", fontWeight: 600,
              border: "1px solid #2E6DA4",
              background: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "#a9c3d8" : "#2E6DA4",
              color: "#fff",
              cursor: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "not-allowed" : "pointer",
            }}
          >
            Apply
          </button>
          {hasActiveFilters && (
            <button
              type="button"
              onClick={clearAllFilters}
              style={{ height: "34px", padding: "0 12px", borderRadius: "8px", border: "1px solid #E4E7EC", background: "#F9FAFB", color: "#475467", fontSize: "12px", fontWeight: 600, cursor: "pointer" }}
            >
              Clear Filters
            </button>
          )}
        </div>
        {isDateRangeInvalid && (
          <div style={{ marginTop: "8px", fontSize: "11px", color: "#DC2626", fontWeight: 600 }}>
            "Created From" date must be on or before "Created To" date.
          </div>
        )}
      </div>
      <div className="datatable__container">

        {roleData && (
          <Table
            data={filteredRoleData}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            searchPlaceholder="Search by Role Name, Description"
            searchInputStyle={{ width: "19em" }}
            addButtonLabel={t("createroleaddbuttonlabel")}
            addNewHandler={addNewHandler}
            showExport={false}
            showExcelExport={true}
            exportData={exportData}
            exportColumns={roleTableDatacolumnsForExport}
            exportFileName="RoleManagement"
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={filteredRoleData.length}
            headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #EEF1F5",
              borderRadius: "10px",
              boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
            }}
          />
        )}
      </div>

      <Modal show={isShow}>
        <Modal.Header closeButton onClick={hideModal}>
          <Modal.Title>Alert !</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure, you want to delete the role ?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="delete_user_btn"
            onClick={hideModal}>
            Cancel
          </Button>
          <Button
            onClick={deleteRoleByRoleId}
            variant="dark"
            className="create_user_btn">
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
});

export default RoleTable;
